import script from "./AppDatesNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDatesNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AppDatesNavigation.vue?vue&type=style&index=0&id=54e3c171&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e3c171"]])

export default __exports__